<div class="drive-shortcut-container">
  <ul *ngFor="let shortCut of shortCuts">
    <li attr.data-cy="{{shortCutModel.title}}"
        [ngClass]="{'highlight-node': breadcrumbs?.length === 2 && breadcrumbs[1]?.title === shortCutModel?.title}"
        *ngFor="let shortCutModel of shortCut" class="p-l-9 flex flex-col justify-center items-start">
      <div (click)="onclickItem(shortCutModel)">
        <i class="{{shortCutModel.icon}}"></i>
        <span>{{shortCutModel.title}}</span>
      </div>
    </li>
  </ul>
</div>


